import React, { useCallback } from "react";
import { IQrProps } from '../../interface/index';
import './index.scss';

const QrCodeContent = (props: IQrProps) => {
    const { className = '', codeOptions, id} = props;
    const imgRef = useCallback((node: HTMLDivElement) => {
        if (node) {
            node.innerHTML = '';
            node.id = id;
            new QRCode(node, codeOptions);
        }
    }, [codeOptions.width, codeOptions.height, codeOptions.text]);

    return <div className={`qr-code ${className}`} ref={imgRef}></div>;
};
export {
    QrCodeContent
}
